import { createFileRoute } from '@tanstack/react-router';
import PayorsPage from '@/pages/setup/payors/PayorsPage';
import { requireSetupPageAccess } from '@/lib/setup-route-guard';

export interface PayorsSearch {
  id?: string;
}

export const Route = createFileRoute('/_authenticated/setup/payors')({
  beforeLoad: () => requireSetupPageAccess('/setup/payors'),
  validateSearch: (raw: Record<string, unknown>): PayorsSearch => ({
    id: (raw.id as string) ?? undefined,
  }),
  component: PayorsPage,
});
